
import React from 'react';
import Card from '../../../components/base/Card';

export default function Features() {
  const features = [
    {
      icon: 'ri-book-2-line',
      title: '旅のしおり作成',
      description: 'AIが提案する最適なルートで、あなただけの旅行プランを簡単に作成できます。',
      image: '/images/feature-001.jpg'
    },
    {
      icon: 'ri-robot-line',
      title: 'AI提案機能',
      description: '機械学習によりあなたの好みを分析し、パーソナライズされた観光スポットを提案します。',
      image: '/images/feature-002.jpg'
    },
    {
      icon: 'ri-notification-3-line',
      title: '通知機能',
      description: '出発時間や予約確認など、大切な情報をタイムリーにお知らせします。',
      image: '/images/feature-003.jpg'
    },
    {
      icon: 'ri-share-line',
      title: '友達共有',
      description: '作成したプランを友達と簡単に共有。みんなで素敵な旅の思い出を作りましょう。',
      image: '/images/feature-004.jpg'
    }
  ];

  return (
    <section className="py-20 bg-[#F6F8FA]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-[#111827] mb-4">
            旅行をもっと楽しく、もっと簡単に
          </h2>
          <p className="text-xl text-[#6B7280] max-w-3xl mx-auto">
            SOCIAL TRIPの革新的な機能で、あなたの旅行体験を次のレベルへ
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <Card key={index} hover className="p-6 h-full">
              <div className="aspect-video mb-6 rounded-xl overflow-hidden">
                <img 
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gradient-to-r from-[#02D0F0] to-[#07DBCA] text-white mb-4">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-[#111827] mb-3">
                {feature.title}
              </h3>
              <p className="text-[#6B7280] leading-relaxed">
                {feature.description}
              </p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
